
import { FdmPlugin, FdmPluginInterface } from './plugins';

// import * as _ from 'lodash';

const Cesium = (<any>window).Cesium;


export class LiveDataController extends FdmPlugin implements FdmPluginInterface {

    // required name identifier
    static meta = {
        label: 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.LABEL',
        name: 'live-data-controller',
        translator: 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER',
        tooltip: 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.TOOLTIP',
        shortcut: false,
        icon: 'satellite-dish',

        types: [ 
            FdmPlugin.types.transformController, 
            FdmPlugin.types.entityController 
        ],

        category: FdmPlugin.category.advanced,
        cardinality: FdmPlugin.cardinality.one
    };

    // our controls
    controls:any = {
        info: { type:'info', value:'', translateValue:true, translateExtra:false },
        distance: { type:'check', value:true },
        // dataFeed: { type:'check', value:false },
        // dataFeedURL: { type:'url', value:'', noshow:true },
        // dataFeedPulse: { type:'number', value:30, noshow:true }

    }

    // the tracked entities
    originalEntities:any = [];

    // default pulse mode
    pulseSeconds = 1;
    


    objectInjected() {

        if ( this.object && this.object.entities ) {
            this.originalEntities = this.object.entities.values;
        } else {
            this.originalEntities = [this.object];
        }

        this.startPulse();
    }

    end() {
        this.stopPulse();
    }

    pulse() {

        this.controls.info.value = 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.NO_TRACKING';

        // if we're tracking distance to camera
        if ( this.controls.distance.value ) {

            const camdist = this.services.mapService.viewer.camera.position;
            this.originalEntities.forEach ( ee => {
                if ( ee ) {
                    this.services.coordHelper.getCoordFromCesiumObject(ee).then ( coord => {
                        if ( coord ) {
                            this.setTypeValue ( ee, 'distanceToCamera', Math.floor ( Cesium.Cartesian3.distance ( coord, camdist ) ) );
                            // console.log('##EE', coord, this.getTypeValue ( ee, 'distanceToCamera' ) );
                        } else {
                            // console.log('##EE error', coord, ee );
                        }
                    });
                }
            });

            this.controls.info.value = 'PLUGINS.DYNAMIC_PROPERTY_CONTROLLER.TRACKING';
            this.controls.info.extra = this.originalEntities.length
            // console.log('!!trackedCameraDistance', this.originalEntities.length );
        }

    }

    getTypeValue ( ee:any, type:string = 'dunno' ) {
        if ( ee && ee['__live_data'] ) {
            return ee['__live_data'][type];
        }
        return null;
    }

    setTypeValue ( ee:any, type:string = 'dunno', value:any = null ) {

        if ( !ee ) {
            return null;
        }

        if ( !ee['__live_data'] ) {
            ee['__live_data'] = {};
        }

        ee['__live_data'][type] = value;
    }

    // may not be needed, but ...
    refresh( newvalue = null, section:any = null ) {
        // check in with mama
        super.refresh ( newvalue, section );
/*
        if ( this.controls.dataFeed.value ) {
            this.turnOn(['dataFeedURL','dataFeedPulse']);
        } else {
            this.turnOff(['dataFeedURL','dataFeedPulse']);

        }
*/
    }
    
}


